import authFetch from './httpClient';
import { IResult } from '../models/HttpResult';
import { ConceptCategory } from '../models/Entities/Contracts/ConceptCategory';
import { NewConceptCategory } from '../models/Entities/Contracts/NewConceptCategory';
import * as Sentry from '@sentry/react';

const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'concept-categories';

const request = async <T>(url: string, options: RequestInit): Promise<T> => {
  try {
    const response = await authFetch(url, {
      ...options,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...(options.headers as Record<string, string> | undefined)
      }
    });

    if (!response.ok) {
      Sentry.captureException(response);
      throw response;
    }

    const data: IResult<T> = await response.json();
    return data.data;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};

export const GetAllConceptCategories = async (): Promise<ConceptCategory[]> => {
  return request<ConceptCategory[]>(BaseURL, { method: 'GET' });
};

export const GetConceptCategoryById = async (id: number): Promise<ConceptCategory> => {
  return request<ConceptCategory>(`${BaseURL}/${id}`, { method: 'GET' });
};

export const CreateConceptCategory = async (
  newConceptCategory: NewConceptCategory
): Promise<ConceptCategory> => {
  return request<ConceptCategory>(BaseURL, {
    method: 'POST',
    body: JSON.stringify(newConceptCategory)
  });
};

export const UpdateConceptCategory = async (
  conceptCategory: ConceptCategory
): Promise<ConceptCategory> => {
  return request<ConceptCategory>(BaseURL, {
    method: 'PUT',
    body: JSON.stringify(conceptCategory)
  });
};

export const DeleteConceptCategory = async (id: number): Promise<boolean> => {
  return request<boolean>(`${BaseURL}/${id}`, { method: 'DELETE' });
};
